export default "<div class=\"indicator-container\">\n\t<div title=\"{{networkState}}\" class=\"bulb {{networkState}}\"></div>\n</div>";